import { Construction } from "lucide-react";
import { Card } from "@/design-system/components/ui";
import { PageHeader } from "@/components/layout/PageHeader";

interface Props {
  title: string;
  phase: string;
  description: string;
}

export function PlaceholderPage({ title, phase, description }: Props) {
  return (
    <>
      <PageHeader eyebrow={phase} title={title} description={description} />
      <Card className="flex flex-col items-center text-center py-space-7">
        <Construction
          size={40}
          strokeWidth={1.5}
          className="text-gold-shadow mb-space-3"
          aria-hidden
        />
        <h2 className="font-display font-bold text-h3 text-onyx m-0 mb-space-2 normal-case tracking-normal">
          Coming soon
        </h2>
        <p className="text-body text-gray-mid m-0 max-w-reading">
          This section is part of the next platform release. Core platform features (auth, users,
          documents, dashboard, audit, reports) are live. Module pages light up as each phase is
          delivered.
        </p>
      </Card>
    </>
  );
}
